export const ar = {
    // --- Direction & Formatting ---
    dir: 'rtl',
    align: 'right',

    // --- المصادقة والأمان (Auth & Security) ---
    loginTab: "تسجيل الدخول",
    signupTab: "إنشاء حساب",
    companyName: "اسم الشركة",
    userName: "اسم المستخدم",
    phoneNumber: "رقم الهاتف", 
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    loginBtn: "تسجيل الدخول",
    signupBtn: "تسجيل حساب جديد",
    processing: "جاري المعالجة...",
    forgetPassLink: "نسيت كلمة المرور؟",
    resetTitle: "إعادة تعيين كلمة المرور",
    resetSub: "أدخل بريدك الإلكتروني لإرسال رابط استعادة الحساب",
    yourEmail: "بريدك الإلكتروني",
    sendLinkBtn: "إرسال الرابط",
    sending: "جاري الإرسال...",
    backToLogin: "العودة لتسجيل الدخول",
    loginError: "خطأ في البريد الإلكتروني أو كلمة المرور",
    signupSuccess: "تم تسجيل الحساب بنجاح!",
    signupError: "هذه الشركة مسجلة مسبقاً في نظامنا.",
    forgotSuccess: "📩 تم إرسال رابط إعادة التعيين لبريدك الإلكتروني",
    forgotError: "فشل إرسال الطلب، تأكد من البيانات",
    otpTitle: "التحقق الأمني الإضافي",
    otpSub: "لقد رصدنا محاولة دخول من جهاز جديد، يرجى إدخال رمز التحقق (OTP) المرسل إلى بريدك الإلكتروني لمرة واحدة.",
    otpPlaceholder: "أدخل الرمز المكون من 6 أرقام",
    verifyBtn: "تأكيد الرمز والدخول",
    verifying: "جاري التحقق...",

    // --- تعيين كلمة المرور أول مرة (Password Activation) ---
    activateTitle: 'تعيين كلمة المرور',
    activateSubtitle: 'مرحباً بك! يرجى اختيار اسم مستخدم وكلمة مرور آمنة لتفعيل حسابك في النظام.',
    labelUser: 'اسم المستخدم',
    placeholderUser: 'أدخل اسم المستخدم',
    labelNew: 'كلمة المرور الجديدة',
    labelConfirm: 'تأكيد كلمة المرور',
    btnActivate: 'تفعيل الحساب',
    btnLoading: 'جاري التفعيل...',
    errMatch: 'كلمات المرور غير متطابقة!',
    errWeakPassword: '❌ يجب أن تكون كلمة المرور 8 رموز على الأقل، وتحتوي على حرف كبير، حرف صغير، رقم، ورمز خاص (#@$!).',
    successMsg: '✅ تم تفعيل الحساب بنجاح! جاري تحويلك...',
    errUnknown: '❌ فشل التفعيل. قد يكون الرابط منتهي الصلاحية.',

    // --- إعدادات الحساب (Account Settings) ---
    settingsTitle: 'إعدادات الحساب ⚙️',
    labelCompany: 'اسم الشركة',
    labelAdmin: 'اسم المسؤول',
    labelEmail: 'البريد الإلكتروني للمسؤول',
    labelCurrentPassword: 'كلمة المرور الحالية 🔑',
    labelPassword: 'كلمة المرور الجديدة',
    placeholderCurrentPass: 'أدخل كلمة المرور الحالية لتتمكن من التغيير',
    placeholderPass: 'اتركه فارغاً للاحتفاظ بالحالية',
    dangerZone: 'منطقة الخطر',
    btnDeleteAccount: 'حذف حسابي الشخصي',
    deleteConfirm: 'هل أنت متأكد من حذف حسابك الشخصي؟ (بيانات الشركة ستظل محفوظة لدى الدعم الفني)',
    deleteErr: 'حدث خطأ أثناء الحذف. يرجى التأكد من الاتصال بالسيرفر.',
    companyNote: 'هل ترغب في حذف الشركة بالكامل؟ ',
    contactSupport: 'اتصل بالدعم الفني',
    valEmail: "❌ يرجير إدخال بريد إلكتروني صحيح",
    valCurrentPass: "❌ يرجى إدخال كلمة المرور الحالية أولاً لحفظ التغييرات",
    successUpdateSettings: "✅ تم تحديث الإعدادات بنجاح",
    failUpdateSettings: "فشل التحديث",

    // --- القوائم والشريط الجانبي (Navigation & Layout) ---
    mainMenu: "القائمة الرئيسية",
    dashboard: "لوحة التحكم",
    vendorsEntry: "إدخال الموردين",
    banksList: "قائمة البنوك",
    addMember: "إضافة عضو",
    manageMembers: "إدارة الأعضاء",
    signOut: "تسجيل الخروج",
    daysLeft: "يوم متبقي",
    mySettings: "إعداداتي",
    logout: "خروج",
    welcome: "مرحباً بك من جديد",
    adminAccess: "تم تفعيل صلاحيات المسؤول الكاملة.",
    employeeAccess: "مرحباً بك في لوحة التحكم الخاصة بك.",
    manageView: "إدارة وعرض",
    noAccess: "غير مصرح لك",
    shareAccess: "مشاركة الدخول",
    copied: "تم نسخ الرابط بنجاح!",
    digitalArchive: "الأرشيف الرقمي",

    // --- إدارة أعضاء الفريق والصلاحيات (Members Management) ---
    membersTitle: 'إدارة أعضاء الفريق',
    titleCreateMember: 'إنشاء عضو جديد',
    titleEditMember: 'تعديل الصلاحيات لـ: ',
    descCreateMember: 'إرسال دعوة انضمام إلى عضو فريق جديد',
    descEditMember: 'تعديل مستويات الوصول والصلاحيات لهذا المستخدم',
    labelName: 'الاسم الكامل',
    secRoles: 'الأدوار (Roles)',
    secScreens: 'الشاشات (Screens)',
    secActions: 'العمليات (Actions)',
    btnInvite: 'إرسال دعوة عبر البريد',
    thName: 'الاسم',
    thEmail: 'البريد الإلكتروني',
    thActions: 'العمليات',
    noMembersData: 'لم يتم العثور على أعضاء في الفريق.',
    confirmDeleteMember: 'هل أنت متأكد من رغبتك في حذف العضو ',

    // --- إدارة البنوك والمصارف (Banks Management) ---
    banksTitle: 'إدارة البنوك والمصارف',
    addBankBtn: '+ إضافة بنك جديد',
    location: '📍 الموقع:',
    swift: '🔑 كود السويفت:',
    notDefined: 'غير محدد',
    update: '✏️ تعديل',
    delete: '🗑️ حذف',
    noBanks: 'لم يتم العثور على أي بنوك مصرفية.',
    loadingBanks: 'جاري تحميل الأنظمة المصرفية...',
    addBankTitle: 'إضافة عقدة بنكية جديدة',
    updateBankTitle: 'تحديث بيانات العقدة البنكية',
    namePlace: 'اسم البنك المصرفي',
    locPlace: 'الموقع (المدينة، الدولة)',
    swiftPlace: 'رمز السويفت (SWIFT)',
    saveBankNode: 'حفظ العقدة المالية',
    confirmDeleteBank: 'هل أنت متأكد من حذف هذا البنك نهائياً من النظام؟',

    // --- الموردين والشركاء (Vendors Management) ---
    vendorsTitle: 'إدارة الموردين والشركاء',
    addVendorBtn: '+ إضافة مورد جديد',
    notAvailable: 'غير محدد',
    updateVendorBtn: '✏️ تعديل',
    deleteVendorBtn: '🗑️ حذف',
    confirmDeleteVendor: 'هل أنتِ متأكدة من حذف هذا المورد نهائياً؟',
    modalAddVendor: 'تسجيل مورد جديد في النظام',
    modalUpdateVendor: 'تحديث بيانات المورد',
    labelVendorName: 'اسم المورد / الشركة',
    placeVendorName: 'أدخلي اسم المورد هنا...',
    labelCountry: 'الدولة',
    placeCountry: 'اختر الدولة...',
    labelCity: 'المدينة',
    placeCity: 'اختر المدينة...',
    placeAddress: 'العنوان التفصيلي',
    placeBuilding: 'المبنى / الطابق',
    placeStreet: 'اسم الشارع',
    placePhone: 'رقم الهاتف',
    placeEmail: 'البريد الإلكتروني',
    placeWebsite: 'الموقع الإلكتروني (اختياري)',
    btnSaveVendor: 'حفظ المورد في النظام',
    btnUpdateVendorSubmit: 'تحديث البيانات',
    vendorHeaderTitle: 'النظرة المالية العامة للمورد',
    vendorHeaderSub: 'عرض فواتير PI & CI للمورد رقم',
    vendorSummaryTitle: 'ملخص فواتير المورد',
    vendorSummaryHeader: 'ملخص الموردين',
    reportRequest: 'طلب تقرير شامل',
    vendorsHeaderNav: 'لوحة التحكم / الموردين والشركاء',
    statusActive: 'الحالة: نشط',
    loadingVendorsSystem: 'جاري تحميل أنظمة الموردين المصرفية...',
    vendorCardTitle: 'الموردين والفواتير المرتبطة',
    linkVendorPlaceholder: '+ ربط مورد جديد بهذه الحاوية',
    noInvoicesForVendor: 'لا توجد فواتير مسجلة لهذا المورد حالياً.',

    // --- الحاوية (Containers Management) ---
    containerSearchPlaceholder: 'بحث عن حاوية...',
    btnAddContainer: '+ إضافة حاوية جديدة',
    modalCreateContainer: 'إنشاء حاوية جديدة',
    modalEditContainer: 'تعديل بيانات الحاوية',
    lblSplit: 'هل هذه الحاوية جزئية / مجزأة؟',
    lblNumber: 'رقم الحاوية',
    lblPart: 'الترميز الفرعي',
    alertBaseNum: 'يرجى إدخال رقم الحاوية الأساسي أولاً',
    alertSuccessCreateContainer: 'تم إنشاء الحاوية بنجاح ✅',
    alertSuccessUpdateContainer: 'تم تحديث بيانات الحاوية بنجاح ✅',
    alertDeleteContainerConfirm: 'هل أنت متأكد من رغبتك في حذف هذه الحاوية؟',
    alertDeleteContainerFail: 'فشلت عملية الحذف: قد لا تملك الصلاحية الكافية',
    placeholderEx: 'مثال: 101',
    placeholderPart: 'أ',
    unknownContainer: 'حاوية غير معروفة',
    updateBL: 'تحديث بوليصة الشحن (BL)',
    uploadBL: 'رفع بوليصة الشحن (BL)',

    // --- الفواتير وشهادات المنشأ (Invoices & COO) ---
    "invoiceTitle": "إدارة إدخال وتدقيق الفواتير وشهادات المنشأ",
  "archive": "📂 الأرشيف المُخزن",
  "archiveTitle": "📂 أرشيف الفواتير",
  "savedInvoices": "📁 الفواتير المحفوظة",
  "noSavedInvoices": "لا توجد فواتير محفوظة حالياً",
  "docId": "📄 التعريف الرقمي للمستند",
  "invNo": "رقم الفاتورة التجارية",
  "invDate": "تاريخ الفاتورة",
  "cooNo": "رقم شهادة المنشأ (COO)",
  "cooDate": "تاريخ شهادة المنشأ",
  "cooInvNo": "رقم الفاتورة في شهادة المنشأ",
  "totalAmount": "المبلغ الكلي",
  "notMatch": "الأرقام غير متطابقة ماليّاً!",
  "entities": "🤝 الأطراف والسلع المتضمنة",
  "vendor": "المورد المعتمد",
  "selectVendor": "-- اختر المورد --",
  "bank": "المصرف المحول",
  "selectBank": "-- اختر البنك --",
  "itemsBtn": "📦 جدول المواد والأسعار",
  "integration": "⚡ الربط والتكامل البرمجي",
  "selectManifest": "اختر المانيفست المرتبط...",
  "checklistBtn": "📋 قائمة التدقيق (Checklist)",
  "linkPi": "🔗 ربط مع فاتورة PI",
  "uploadTitle": "🚀 منصة رفع الملفات الذكية (اضغط للتحليل السحابي الفوري)",
  "heroUploadZone": "🚀 منطقة رفع الملفات (اسحب أو اضغط للتحليل)",
  "accNo": "رقم الحساب البنكي",
  "iban": "رقم الآيبان الدولي (IBAN)",
  "saveInvoiceBtn": "💾 حفظ واعتماد الفاتورة",
  "updateInvoiceBtn": "💾 حفظ وتعديل بيانات الفاتورة الحالية",
  "noFile": "لم يتم رفع ملف",
  "matchError": "⚠️ خطأ في المطابقة: رقم الفاتورة يجب أن يكون مطابقاً تماماً لرقم شهادة المنشأ (COO Number).",
  "selectVendorAlert": "الرجاء اختيار المورد أولاً!",
  "enterInvAlert": "الرجاء إدخال رقم الفاتورة!",
  "enterManifestAlert": "الرجاء اختيار رقم البيان الجمركي المسبق المُرتبط بهذه الفاتورة!",
  "successSaveInvoice": "✅ تم الحفظ والترحيل بنجاح!",
  "successUpdateInvoice": "✅ تم تحديث الفاتورة بنجاح!",
  "dataError": "خطأ في بنية البيانات:",
  "saveFailedInvoice": "فشلت عملية الحفظ:",
  "combineBtn": "📦 دمج وتحميل المستندات",
  "combineSub": "توليد ملف شحنة موحد PDF",
  "scanning": "جاري تحليل الفاتورة بالذكاء الاصطناعي...",
  "uploadCI": "الفاتورة التجارية (CI)",
  "uploadCOO": "شهادة المنشأ (COO)",
  "uploadPL": "كشف التعبئة (PL)",
  "dropFiles": "اضغط لرفع الملف سحابياً",
  "analyzeBtn": "🤖 تحليل الفاتورة بالذكاء الاصطناعي",
  "runAiExtraction": "تشغيل استخراج الذكاء الاصطناعي",
  "selectCiAlert": "الرجاء رفع الفاتورة التجارية (CI) أولاً للتمكن من تحليلها!",
  
    // --- الفواتير المبدئية (PI Invoices) ---
   "pageTitle": "إدخال الفاتورة المبدئية (PI)",
    "titleEdit": "تعديل الفاتورة المبدئية (PI)",
    
    "btnBack": "رجوع",
    "btnRunAi": "تشغيل استخراج الذكاء الاصطناعي",
    "btnCombineDocs": "دمج وتحميل المستندات",
    "btnSaveInvoice": "حفظ الفاتورة",
    "btnUpdateInvoice": "تحديث الفاتورة",
    "btnCancel": "إلغاء التعديل",
    "btnViewSaved": "عرض الفواتير المحفوظة",
    
    "reqDocsTitle": "المستندات المطلوبة (انقر للتحليل بالذكاء الاصطناعي بعد الرفع)",
    "extraDocsTitle": "مستندات إضافية",
    
    "docPiInvoice": "فاتورة مبدئية (PI)",
    "docPackingList": "قائمة التعبئة",
    "docContract": "العقد",
    
    "lblPreManifest": "رقم البيان المسبق",
    "selectManifest": "اختر البيان...",
    "lblVendor": "المورد",
    "selectVendor": "اختر المورد...",
    "lblInvoiceDate": "تاريخ الفاتورة",
    "lblInvoiceNumber": "رقم الفاتورة",
    "lblTotalAmount": "الإجمالي / الرقم",
    
    "cardItemTable": "جدول المواد",
    "cardCheckList": "قائمة التحقق",
    
    "savedDrawerTitle": "الفواتير المحفوظة",
    "noSavedInvoices": "لا توجد فواتير محفوظة",
    
    "statusScanning": "جاري الفحص...",
    "statusCombining": "جاري الدمج...",
    "statusProcessing": "جاري المعالجة...",
    
    "aiSuccess": "✨ تم تحليل حزمة المستندات بنجاح بواسطة الذكاء الاصطناعي!",
    "aiFail": "❌ فشل استخراج البيانات بالذكاء الاصطناعي",
    "noFilesErr": "❌ لا توجد ملفات مرفوعة لدمجها!",
    "combineSuccess": "✨ تم دمج المستندات وتحميلها بنجاح!",
    "combineFail": "❌ فشل دمج الملفات. التأكد من صحة الصيغ.",
    "noFileForAi": "⚠️ يرجى رفع فاتورة PI أو قائمة التعبئة أولاً للتحليل!",
    "saveSuccess": "✅ تم حفظ الفاتورة بنجاح!",
    "saveFail": "❌ فشل حفظ الفاتورة",
    "updateSuccess": "✅ تم تحديث الفاتورة بنجاح!",
    "deleteSuccess": "🗑 تم حذف الفاتورة بنجاح",
    "errInvNo": "❌ يرجى إدخال رقم الفاتورة!",
    "errInvDate": "❌ يرجى اختيار تاريخ الفاتورة!",
    "errAmount": "❌ يرجى إدخال مبلغ صحيح!",
    "errManifest": "❌ يرجى اختيار رقم البيان المسبق!",
    "errVendor": "❌ يرجى اختيار المورد!",
    "errPiFile": "❌ يرجى رفع ملف الفاتورة المبدئية!",
    
    "typePI": "فاتورة أولية (PI)",
    "typeCI": "فاتورة تجارية (CI)",

    // --- البيان الجمركي والمانيفست (Manifests) ---
    manifestTitle: 'إدارة البيانات المسبقة (المانيفست)',
    manifestPlaceholder: 'أدخل رقم البيان أو المانيفست...',
    thInfo: 'معلومات البيان',
    thDetails: 'تفاصيل الفواتير المرتبطة',
    unknownVendor: 'غير معروف',
    noLinked: 'لا توجد فواتير مرتبطة بهذا البيان حالياً.',
    alertNumber: 'الرجاء إدخال الرقم أولاً',
    alertDeleteManifestConfirm: 'هل أنت متأكد من رغبتك في حذف هذا البيان؟',
    loadingManifests: 'جاري تحميل بيانات البيانات المسبقة...',
    updateManifest: 'تحديث البيان (Manifest)',
    uploadManifest: 'رفع البيان (Manifest)',
    manifestConflictAlert: '⚠️ تنبيه: الفواتير مرتبطة ببيانات مختلفة!',
    noneManifestOption: '🫙 بدون بيان جمركي (None)',

    // --- إدارة الحوالات والتسلسل البنكي (Bank Transfers) ---
    bankTransfersTitle: "شاشة إدارة الحوالات البنكية",
    invoice: "الفاتورة",
    fetching: "جاري الجلب...",
    searchInvoiceTitle: "🔍 البحث عن فاتورة",
    invoiceNoPlaceholder: "رقم الفاتورة...",
    searchBtn: "ابحث الآن",
    changeInvoiceBtn: "🔄 ابحث عن فاتورة أخرى",
    paidAmount: "المبلغ المدفوع",
    remainingAmount: "المتبقي",
    invoiceDocs: "📄 مستندات الفاتورة:",
    amountPlaceholder: "المبلغ",
    completedInvoice: "لقد تم اكتمال الفاتورة بالكامل",
    previewMode: "⚠️ وضع العرض السريع والرفع فقط للحوالات الحالية.",
    cancelledLabel: "(ملغاة)",
    alertNoInvoice: "الرجاء إدخال رقم الفاتورة أولاً",
    alertFetchFail: "فشل في جلب بيانات هذه الفاتورة.",
    alertSearchFail: "لم يتم العثور على الفاتورة.",
    alertFileNotAvailable: "الملف غير متوفر بعد.",
    alertNotAllowedSearch: "غير مسموح من شاشة البحث.",
    alertCompleted: "مكتملة.",
    alertInvalidAmount: "المبلغ غير صحيح.",
    alertAddSuccess: "تمت الإضافة بنجاح ✅",
    alertAddFail: "فشل الإضافة",
    alertSwiftSuccess: "تم رفع ملف السوفت بنجاح وتحول اللون للأخضر 🟢",
    alertSwiftFail: "فشل رفع السوفت",
    alertCancelConfirm: "هل أنت متأكد من إلغاء الحوالة مالياً؟",
    alertCancelSuccess: "تم إلغاء الحوالة بنجاح 🛑",
    alertCancelFail: "فشل الإلغاء",
    alertDeleteConfirm: "⚠️ هل تريد حذف الحوالة نهائياً من قاعدة البيانات؟",
    alertDeleteSuccess: "تم الحذف النهائي بنجاح 🗑️",
    alertDeleteFail: "فشل الحذف الكلي",
    alertDeleteSwiftConfirm: "هل أنت متأكد من حذف السوفت؟",
    alertDeleteSwiftSuccess: "تم حذف ملف السوفت بنجاح ✅",
    alertDeleteSwiftFail: "فشل حذف السوفت",
    fullPayment: "تم دفع كامل المبلغ",
    finalPayment: "الدفع النهائي",

    // تقارير الحوالات البنكية
    transfersReportTitle: 'تقرير تسلسل الحوالات البنكية',
    transfersLegend: 'الأخضر: تم رفع ملف Swift بنجاح',
    amountPlace: 'فلترة بالمبلغ...',
    loadingTransfersData: 'جاري تحميل البيانات الحوالات...',
    noTransfersData: 'لا توجد حوالات تطابق معايير هذا البحث.',
    labelVendor: 'المورد:',
    labelInvoice: 'الفاتورة:',
    labelAmount: 'المبلغ:',
    labelDate: 'التاريخ:',
    statusCancelled: 'ملغاة',
    statusSwift: '✔ سويفت',
    statusPending: 'قيد الانتظار',
    textCancelled: '(ملغاة)',

    // --- سجل الرقابة والأرشيف والاستعادة (Audit Log & Trash) ---
    auditTitle: "سجل أنشطة النظام والاستعادة",
    trashBin: "🗑️ سلة المهملات (العناصر المنتظرة للاستعادة)",
    allActivities: "كل الأنشطة",
    bankAccounts: "حسابات البنوك",
    vendors: "إدارة الموردين",
    containers: "إدارة الحاويات",
    invoices: "الفواتير الحقيقية",
    piInvoices: "الفواتير المبدئية (PI)",
    bankTransfers: "تحويلات البنوك",
    manifests: "المنافيستو (Manifests)",
    preManifests: "المنفيستو المسبق",
    screens: "إعدادات الشاشات", 
    filterUser: "ابحث باسم الموظف...",
    filterStart: "من تاريخ",
    filterEnd: "إلى تاريخ",
    thUser: "الموظف",
    thModule: "الشاشة / القسم",
    thAction: "نوع العملية",
    thDetails: "الوصف والتفاصيل",
    thTimestamp: "الوقت والتاريخ",
    thRecovery: "الاستعادة",
    noLogs: "لم يتم العثور على أي سجلات متطابقة.",
    restoredStatus: "مسترجع ✅",
    restoreBtn: "استعادة",
    restoring: "جاري الاستعادة...",
    confirmRestoreMsg: "هل أنت متأكد من استعادة هذا العنصر؟",
    successRestoreMsg: "تمت استعادة البيانات بنجاح وإعادتها للشاشة النشطة!",
    errorRestoreMsg: "خطأ أثناء الاستعادة: ",
    audit: "الرقابة والاستعادة",

    // --- الأرشيف الرقمي الموحد (Unified Documents Archive) ---
    archiveUnifiedTitle: "أرشيف المستندات والملفات الموحد",
    archiveUnifiedSubtitle: "عرض مركزي شامل لكافة الملفات التي تم رفعها عبر أقسام النظام",
    totalFiles: "إجمالي الملفات مؤرشفة",
    archiveSearchPlaceholder: "ابحث باسم الملف أو التصنيف (مثلاً: بوليصة شحن، ملف سويفت)...",
    noDocs: "لا توجد أي مستندات أو نتائج تطابق بحثك حالياً.",
    loadingArchive: "جاري تحميل الأرشيف الرقمي الموحد...",
    tableName: "اسم المستند الأصلي",
    tableType: "التصنيف / نوع المستند",
    tableDate: "تاريخ ووقت الرفع",
    tableActions: "الإجراءات",
    viewBtn: "فتح وعرض المستند",

    // --- أزرار ورسائل عامة (Common Actions & Alerts) ---
    back: 'رجوع →',
    backBtn: 'رجوع',
    btnConfirm: 'تأكيد الحفظ',
    btnCancel: 'إلغاء',
    cancel: 'إلغاء الأمر',
    save: 'حفظ',
    btnSave: 'حفظ التغييرات',
    btnUpdate: 'تحديث السجل',
    updateBtn: 'تعديل',
    edit: 'تعديل',
    btnEdit: 'تعديل',
    btnDelete: 'حذف',
    linked: 'مرتبط  ✓',
    unlinkTitle: 'فك ارتباط الفاتورة',
    linkToContainer: 'ربط بالحاوية',
    newInvoice: 'فاتورة جديدة',
    saving: 'جاري الحفظ...',
    confirmChanges: 'تأكيد جميع التغييرات',
    confirmUnlinkInvoice: 'هل أنت متأكد من فك ارتباط هذه الفاتورة؟',
    alertUnlinkSuccess: 'تم فك ارتباط الفاتورة بنجاح ✅',
    alertUnlinkError: 'حدث خطأ أثناء فك الارتباط',
    alertLinkManifestSuccess: 'تم ربط البيان بالحاوية بنجاح ✅',
    alertLinkManifestError: 'حدث خطأ أثناء ربط البيان',
    alertSaveSuccess: 'تم الحفظ بنجاح ✅',
    alertUploadSuccess: 'تم حفظ الملفات بنجاح!',
    confirmDeleteInvoice: '❌ تحذير: هل أنت متأكد من حذف هذه الفاتورة نهائياً من النظام؟',
    alertDeleteSuccess: 'تم حذف الفاتورة نهائياً بنجاح ✅',
    alertFailed: '❌ فشلت العملية: ',
    alertSuccess: 'تمت العملية بنجاح ✅',
    successSave: '✅ تم الحفظ بنجاح',
    failDelete: '❌ فشلت عملية الحذف',
    failSave: '❌ حدث خطأ أثناء عملية الحفظ',
    loading: 'جاري تحميل البيانات...',
    noData: 'لا توجد بيانات للعرض',
    noDate: 'بلا تاريخ',
    lastModified: 'آخر تعديل',
    invoicesBadge: 'فواتير',
    errorMsg: 'حدث خطأ أثناء جلب البيانات.',
    searchPlace: 'بحث...',
    searchPlaceholder: 'ابحث عن مورد...',
    datePlace: 'فلترة بالتاريخ...',
    totalLabel: 'الإجمالي',
    thTotal: 'المبلغ الإجمالي',
    thPaid: 'المدفوع',
    thRemain: 'المتبقي',
    thStatus: 'الحالة',
    thAction: 'الإجراء',
    thId: 'المعرف',
    thInvoiceNo: 'رقم الفاتورة',
    thDate: 'التاريخ',
    btnPay: '+ ادفع الآن',
    viewDetails: '▼ عرض التفاصيل',
    closeDetails: '▲ إغلاق التفاصيل',


    title: "شاشة إدارة الحوالات البنكية",
    invoice: "الفاتورة",
    fetching: "جاري الجلب...",
    searchTitle: "🔍 البحث عن فاتورة",
    invoiceNoPlaceholder: "رقم الفاتورة...",
    searchBtn: "ابحث الآن",
    changeInvoiceBtn: "🔄 ابحث عن فاتورة أخرى",
    totalAmount: "المبلغ الكلي",
    paidAmount: "المبلغ المدفوع",
    remainingAmount: "المتبقي",
    invoiceDocs: "📁 حزمة المستندات المدمجة التابعة لهذه الفاتورة المعاملة:",
    amountPlaceholder: "المبلغ",
    completedInvoice: "لقد تم اكتمال الفاتورة بالكامل",
    previewMode: "⚠️ وضع العرض السريع والرفع فقط للحوالات الحالية.",
    cancelledLabel: "(ملغاة)",
    loading: "جاري تحديث البيانات... ⏳",
    alertNoInvoice: "الرجاء إدخال رقم الفاتورة أولاً",
    alertFetchFail: "فشل في جلب بيانات هذه الفاتورة.",
    alertSearchFail: "لم يتم العثور على الفاتورة.",
    alertFileNotAvailable: "الملف غير متوفر بعد.",
    alertNotAllowedSearch: "غير مسموح من شاشة البحث.",
    alertCompleted: "مكتملة.",
    alertInvalidAmount: "المبلغ غير صحيح.",
    alertAddSuccess: "تمت الإضافة بنجاح ✅",
    alertAddFail: "فشل الإضافة",
    alertSwiftSuccess: "تم رفع ملف السوفت بنجاح وتحول اللون للأخضر 🟢",
    alertSwiftFail: "فشل رفع السوفت",
    alertCancelConfirm: "هل أنت متأكد من إلغاء الحوالة مالياً؟",
    alertCancelSuccess: "تم إلغاء الحوالة بنجاح 🛑",
    alertCancelFail: "فشل الإلغاء",
    alertDeleteConfirm: "⚠️ هل تريد حذف الحوالة نهائياً من قاعدة البيانات؟",
    alertDeleteSuccess: "تم الحذف النهائي بنجاح 🗑️",
    alertDeleteFail: "فشل الحذف الكلي",
    alertDeleteSwiftConfirm: "هل أنت متأكد من حذف السوفت؟",
    alertDeleteSwiftSuccess: "تم حذف ملف السوفت بنجاح ✅",
    alertDeleteSwiftFail: "فشل حذف السوفت",
    alertUpdateSuccess: "تم التحديث بنجاح ✅",
    alertUpdateFail: "فشل التحديث",
    fullPayment: "كامل الدفعة",
    finalPayment: "الدفعة الأخيرة",
    firstBatch: "الدفعة الأولى",
    secondBatch: "الدفعة الثانية",
    thirdBatch: "الدفعة الثالثة",
    fourthBatch: "الدفعة الرابعة",
    fifthBatch: "الدفعة الخامسة",
    extraBatch: "دفعة إضافية",
    shareInvoice: "مشاركة الفاتورة والحوالات 📲",
    shareSuccess: "📋 تم نسخ كافة بيانات الفاتورة والحوالات إلى الحافظة!",
    combining: "جاري الدمج والتحميل... ⏳",
    combineBtn: "دمج وتحميل الملفات المحددة",
    attachFileErr: "الرجاء إرفاق ملف الحوالة",
    selectNewFileErr: "الرجاء اختيار ملف الحوالة الجديد أولاً",
    exceedsErr: "خطأ: المبلغ المعدل يتجاوز الحد المسموح به للفاتورة!",
    exceedsRemainingErr: "خطأ: المبلغ المدخل أكبر من المبلغ المتبقي للفاتورة!",
    vendor: "المورد",
    bank: "البنك",
    cooNo: "رقم شهادة المنشأ",
    transfersCount: "عدد الحوالات",
    price: "السعر:",
    date: "التاريخ:",
    newFile: "الملف الجديد:",
    save: "حفظ",
    cancel: "إلغاء",
    ready: "جاهز ✅",
    selectFile: "اختر ملف",
    docTypes: {
      pi_invoice: "فاتورة أولية (PI)",
      ci_invoice: "فاتورة تجارية (CI)",
      packing_list: "قائمة التعبئة (Packing List)",
      contract: "العقد (Contract)",
      coo: "شهادة المنشأ (COO)",
      vendor_license: "رخصة المورد",
      bol: "بوليصة الشحن (B/L)",
      manifest: "المانفيست (Manifest)"
    },
    "trackingWindow.title": "سجلات أنشطة النظام واستعادة البيانات",
  "trackingWindow.allActivities": "جميع الأنشطة",
  "trackingWindow.bankAccounts": "الحسابات البنكية",
  "trackingWindow.vendorManagement": "إدارة الموردين",
  "trackingWindow.containerManagement": "إدارة الحاويات",
  "trackingWindow.invoices": "الفواتير",
  "trackingWindow.piInvoices": "الفواتير الأولية (PI)",
  "trackingWindow.bankTransfers": "الحوالات البنكية",
  "trackingWindow.manifests": "المنفيست",
  "trackingWindow.preManifests": "المنفيست الأولي",
  "trackingWindow.searchPlaceholder": "البحث باسم الموظف، الوصف، أو الـ ID...",
  "trackingWindow.from": "من",
  "trackingWindow.to": "إلى",
  "trackingWindow.clear": "مسح",
  "trackingWindow.trashBin": "سلة المحذوفات (العناصر المعلقة للاستعادة)",
  "trackingWindow.colUser": "المستخدم / الموظف",
  "trackingWindow.colModule": "الشاشة / القسم",
  "trackingWindow.colAction": "نوع الإجراء",
  "trackingWindow.colDescription": "الوصف والتفاصيل",
  "trackingWindow.colTimestamp": "التاريخ والوقت",
  "trackingWindow.colRecovery": "الاستعادة",
  "trackingWindow.restored": "تمت الاستعادة",
  "trackingWindow.restoring": "جاري الاستعادة...",
  "trackingWindow.restore": "استعادة",
  "trackingWindow.noLogs": "لا توجد سجلات مطابقة للبحث.",
  "trackingWindow.system": "النظام",
  "invoiceDetails": {
    "title": "إدارة إدخال وتدقيق الفواتير وشهادات المنشأ",
    "docId": "📄 التعريف الرقمي للمستندات",
    "invNo": "رقم الفاتورة التجارية",
    "invDate": "تاريخ الفاتورة",
    "cooNo": "رقم شهادة المنشأ (COO)",
    "cooDate": "تاريخ شهادة المنشأ",
    "totalAmount": "المبلغ الكلي",
    "entities": "🤝 الأطراف والبيانات المصرفية",
    "vendor": "المورد المعتمد",
    "selectVendor": "-- اختر المورد --",
    "bank": "المصرف المحول",
    "selectBank": "-- اختر البنك --",
    "accountNumber": "رقم الحساب المصرفي (Account Number)",
    "iban": "رقم الآيبان (IBAN)",
    "manifest": "رقم البيان الجمركي المسبق",
    "selectManifest": "-- اختر رقم البيان (إجباري في حال اختلاف الحاويات) --",
    "itemsBtn": "📦 جدول المواد والأسعار",
    "checklistBtn": "📋 قائمة التدقيق (Checklist)",
    "saveBtn": "💾 حفظ واعتماد الفاتورة الجديدة",
    "updateBtn": "💾 حفظ وتعديل بيانات الفاتورة الحالية",
    "enterInvAlert": "الرجاء إدخال رقم الفاتورة!",
    "enterManifestAlert": "الرجاء اختيار رقم البيان الجمركي المسبق المُرتبط بهذه الفاتورة!",
    "successSave": "✅ تم الحفظ والترحيل بنجاح!",
    "successUpdate": "✅ تم تحديث الفاتورة بنجاح!",
    "saveFailed": "فشلت العملية:",
    "scanning": "جاري تحليل الفاتورة بالذكاء الاصطناعي...",
    "uploadCI": "الفاتورة التجارية (CI)",
    "uploadCOO": "شهادة المنشأ (COO)",
    "uploadPL": "كشف التعبئة (PL)",
    "analyzeBtn": "🤖 تحليل الفاتورة بالذكاء الاصطناعي",
    "selectCiAlert": "الرجاء رفع الفاتورة التجارية (CI) أولاً للتمكن من تحليلها!",
    "backBtn": "رجوع",
  }
};